var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotel = function SvgHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M2.504 5.748c.694 0 1.258.564 1.258 1.258v5.8h16.461l.001-2.77a1.258 1.258 0 0 1 2.515 0v7.059c0 .333-.132.654-.368.89a1.26 1.26 0 0 1-2.147-.89V15.32H3.76v1.774c0 .333-.131.654-.367.89a1.261 1.261 0 0 1-2.148-.89V7.006c0-.694.564-1.258 1.258-1.258zm15.354 3.03a1.259 1.259 0 0 1 0 2.516H6.213a1.258 1.258 0 0 1 0-2.515h11.645z"
  })));
};
export default SvgHotel;